import { URL_CARDS, API_WALLET_URL } from 'config'
import { apiCall } from './base'

export const getShipping = async (id) => {
  const result = apiCall(`${URL_CARDS}/api/v1/shipping/${id}`, {
    baseURL: API_WALLET_URL,
    method: 'GET',
    withCredentials: false,
    immediately: true
  })
  return result
}
